import { ClassUtils } from "../../utils/ClassUtils";
import { Pool } from "../../utils/Pool";
const className = "DrawLineCmd";
export class DrawLineCmd {
    constructor() {
        this.lineWidth = 0;
    }
    static create(fromX, fromY, toX, toY, lineColor, lineWidth, percent) {
        var cmd = Pool.getItemByClass(className, DrawLineCmd);
        cmd.fromX = fromX;
        cmd.fromY = fromY;
        cmd.toX = toX;
        cmd.toY = toY;
        cmd.lineColor = lineColor;
        cmd.lineWidth = lineWidth;
        cmd.percent = percent;
        return cmd;
    }
    recover() {
        Pool.recover(className, this);
    }
    run(runner, gx, gy) {
        let offset = (this.lineWidth < 1 || this.lineWidth % 2 === 0) ? 0 : 0.5;
        if (this.percent && runner.sprite) {
            let w = runner.sprite.width;
            let h = runner.sprite.height;
            runner._drawLine(gx, gy, this.fromX * w + offset, this.fromY * h + offset, this.toX * w + offset, this.toY * h + offset, this.lineColor, this.lineWidth, 0);
        }
        else
            runner._drawLine(gx, gy, this.fromX + offset, this.fromY + offset, this.toX + offset, this.toY + offset, this.lineColor, this.lineWidth, 0);
    }
    get cmdID() {
        return DrawLineCmd.ID;
    }
    getBounds(assembler) {
        let lineWidth;
        lineWidth = this.lineWidth * 0.5;
        let fromX = this.fromX, fromY = this.fromY, toX = this.toX, toY = this.toY;
        if (this.percent) {
            fromX *= assembler.width;
            fromY *= assembler.height;
            toX *= assembler.width;
            toY *= assembler.height;
        }
        if (fromX == toX) {
            assembler.points.push(fromX + lineWidth, fromY, toX + lineWidth, toY, fromX - lineWidth, fromY, toX - lineWidth, toY);
        }
        else if (fromY == toY) {
            assembler.points.push(fromX, fromY + lineWidth, toX, toY + lineWidth, fromX, fromY - lineWidth, toX, toY - lineWidth);
        }
        else {
            assembler.points.push(fromX, fromY, toX, toY);
        }
    }
}
DrawLineCmd.ID = className;
ClassUtils.regClass(className, DrawLineCmd);
